import script from "./HistoricoViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricoViewer.vue?vue&type=script&setup=true&lang=js"

import "./HistoricoViewer.vue?vue&type=style&index=0&id=36d28ca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d28ca2"]])

export default __exports__